import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "../firebase/client";
import type { AuthState } from "../types/auth.types";

export function useAuth(): AuthState {
	const [state, setState] = useState<AuthState>(
		auth.currentUser && !auth.currentUser.isAnonymous ? "authenticated" : "loading",
	);

	useEffect(() => {
		return onAuthStateChanged(auth, (user) => {
			setState(user && !user.isAnonymous ? "authenticated" : "unauthenticated");
		});
	}, []);

	return state;
}
